import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { useMemo } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'https://luxejewels-enni.onrender.com/api';

export const useApi = () => {
  const { token } = useAuth();

  const api = useMemo(() => {
    const instance = axios.create({
      baseURL: API_URL,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (token) {
      instance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }

    return instance;
  }, [token]);

  return api;
};
